const selectStyles = {
    control: (base) => ({
        ...base,
        height: '31px', // Adjust the height for "sm"
        minHeight: '31px', // Ensures consistency
        fontSize: '0.84rem', // Bootstrap's small font size
    }),
    valueContainer: (base) => ({
        ...base,
        marginTop: -3,
    }),
    clearIndicator: (base) => ({
        ...base,
        marginTop: -3,
    }),
    dropdownIndicator: (base) => ({
        ...base,
        marginTop: -3,
    }),
    menu: (base) => ({
        ...base,
        zIndex: 9999, // High z-index to ensure it appears above everything
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 9999, // Ensures menuPortal is also above everything
    }),
};

export { selectStyles };
